import { useState, useEffect, React } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { loggedUser } from "../../redux/userSlice";
import styles from "./Profile.module.css";

function Profile() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [update, setUpdate] = useState(false);

  const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
  });

  const handleUpdate = async () => {
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_PORT}/users`,
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        data: {
          firstname,
          lastname,
          email,
          address,
          password,
          password2,
        },
      });
      dispatch(
        loggedUser({
          email: response.data.email,
          firstname: response.data.firstname,
          lastname: response.data.lastname,
          address: response.data.address,
        })
      );
      Toast.fire({
        icon: "success",
        title: `Se han actualizado los datos`,
      });
      setUpdate(true);
    } catch (error) {
      setError(error.response.data.msg);
    }
  };

  useEffect(() => {}, [update]);

  return (
    <>
      <div
        className={
          styles.main + " d-flex flex-column justify-content-center px-4"
        }
      >
        <div className="mt-2">
          <h2 style={{ color: "#606a72" }}>Actualizá tus datos personales</h2>
          <div className={styles.form + " bg-light px-4 shadow"}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpdate();
              }}
            >
              <div className="mb-2">
                <label
                  style={{ color: "#606a72" }}
                  htmlFor="exampleInputEmail1"
                  className="form-label mt-3"
                >
                  Nombre
                </label>
                <input
                  placeholder={user.firstname}
                  value={firstname}
                  type="text"
                  name="name"
                  className="form-control"
                  onChange={(event) => {
                    setFirstname(event.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="exampleInputEmail1"
                  style={{ color: "#606a72" }}
                  className="form-label"
                >
                  Apellido
                </label>
                <input
                  placeholder={user.lastname}
                  value={lastname}
                  type="text"
                  name="lastname"
                  className="form-control"
                  onChange={(event) => {
                    setLastname(event.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="exampleInputEmail1"
                  style={{ color: "#606a72" }}
                  className="form-label"
                >
                  Email
                </label>
                <input
                  placeholder={user.email}
                  value={email}
                  type="email"
                  name="email"
                  className="form-control"
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setError(null);
                  }}
                />
              </div>

              <div className="mb-2">
                <label
                  htmlFor="exampleInputEmail1"
                  style={{ color: "#606a72" }}
                  className="form-label"
                >
                  Dirección
                </label>

                <input
                  placeholder={user.address}
                  value={address}
                  type="text"
                  name="address"
                  className="form-control"
                  onChange={(event) => {
                    setAddress(event.target.value);
                    setError(null);
                  }}
                />
                {/* </div> */}
              </div>

              <div className="mb-2">
                <label
                  htmlFor="exampleInputPassword1"
                  style={{ color: "#606a72" }}
                  className="form-label"
                >
                  Nueva contraseña
                </label>
                <input
                  placeholder="******"
                  value={password}
                  name="password"
                  type="password"
                  className="form-control"
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError(null);
                  }}
                />
              </div>
              <div className="mb-2">
                <label
                  htmlFor="exampleInputPassword1"
                  style={{ color: "#606a72" }}
                  className="form-label"
                >
                  Repetir nueva contraseña
                </label>
                <input
                  placeholder="******"
                  value={password2}
                  name="password2"
                  type="password"
                  className="form-control"
                  onChange={(event) => {
                    setPassword2(event.target.value);
                    setError(null);
                  }}
                />
              </div>

              <button type="submit" className={styles.btnLogin}>
                Actualizar Datos
              </button>
              {error ? (
                <p style={{ color: "red", marginTop: "5px" }}>{error}</p>
              ) : (
                <></>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
